/**
 * AI 영상이 실패했을 때 학생에게 보일 말(부검 2026-10-26).
 *
 * 🚨 종전에는 세 화면(그림·MV 편집·포스터)이 원인과 상관없이 「다시 눌러 주세요」 만 보였다.
 *    10-26 14:53 콘텐츠 정책 거절을 받은 학생이 18초에 3번 연타했다 — 그림을 바꿔야 풀리는 실패였다.
 *    그림 화면(CutsPage)·포스터 그림(PosterDrawPage)은 이미 원인별로 나눈다. 영상도 같게 한다.
 * 🔑 실패한 영상은 횟수를 돌려준다 — 그 말은 화면마다 따로 붙인다.
 */
export function videoFailureMessage(errorCode: string | null | undefined): string {
  switch (errorCode) {
    case "MODERATION_BLOCKED":
      return "AI 가 영상으로 만들기 어려운 그림이에요. 그림이나 움직임 글을 바꿔서 만들어 주세요.";
    case "BUDGET_EXHAUSTED":
      return "오늘 만들 수 있는 AI 영상을 다 썼어요. 선생님께 알려 주세요.";
    case "PROVIDER_TIMEOUT":
      return "시간이 오래 걸려 멈췄어요. 다시 눌러 주세요.";
    default:
      return "영상을 만들지 못했어요. 다시 눌러 주세요.";
  }
}

